(function() {
    'use strict';
    //angular.module('Waiteraid').config(configBlock);

    /** @ngInject */

    if(_.isFunction(_trackAnalytic))
        angular.module('Waiteraid').config(_trackAnalytic);
})();
